const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

export default EmptyParentComponent;